import script from "./pending-societes.vue?vue&type=script&setup=true&lang=js"
export * from "./pending-societes.vue?vue&type=script&setup=true&lang=js"

import "./pending-societes.vue?vue&type=style&index=0&id=c57c04d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c57c04d2"]])

export default __exports__